import React, { useEffect, useRef } from 'react';
import mermaid from 'mermaid';

const Mermaid = ({ chart }) => {
  const mermaidRef = useRef(null);

  useEffect(() => {
    if (mermaidRef.current) {
      mermaid.initialize({ startOnLoad: true });
      mermaid.contentLoaded();
    }
  }, [chart]);

  const isFlowchart = chart.trim().startsWith('flowchart');

  return (
    <div
      ref={mermaidRef}
      className="mermaid"
      style={{
        display: isFlowchart ? 'flex' : 'block',
        justifyContent: isFlowchart ? 'center' : 'initial',
        marginLeft: '30px',
      }}
    >
      {chart}
    </div>
  );
};

export default Mermaid;
